import React, { useState, useEffect } from "react";
import ScoreLogo from "../../assets/svg/exampage/scoreLogo.png";
import ArrowLeft from "../../assets/svg/exampage/ArrowLeft.svg";
import { ROUTES } from "../../constants/routes";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { ExamConfigHelper } from "../../constants/examConfig";

export const ExamPageBanner = ({ currentExam }) => {
  const history = useHistory();
  const [isMobile, setIsMobile] = useState(false);

  // Check if mobile on component mount
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkMobile(); // Check initially
    window.addEventListener("resize", checkMobile);

    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const shouldShowRewardsSection = ExamConfigHelper.shouldShowRewardsSection(currentExam);

  // Function to get display name - show YEC only on mobile for Youth Entrepreneurship Challenge
  const getDisplayBannerName = (examName) => {
    if (!examName) return "";

    // If it's Youth Entrepreneurship Challenge and on mobile, show YEC
    if (examName.toLowerCase() === "youth entrepreneurship challenge" && isMobile) {
      return "YEC";
    }

    return ExamConfigHelper.getDisplayName(examName);
  };

  const getImage = (examName) => ExamConfigHelper.getBannerImage(examName);

  const handleBackButtonClick = () => {
    history.push(ROUTES.DASHBOARD);
  };

  return (
    <div>
      <figure className="banner">
        {currentExam && <img className="banner-img" src={getImage(currentExam)} alt={currentExam} />}
        <img onClick={handleBackButtonClick} className="arrowLeft" src={ArrowLeft} alt="logo" />
        {currentExam === "score" ? (
          <img className="logo-img" src={ScoreLogo} alt="logo" />
        ) : (
          <>
            <h1 className="banner-heading">{getDisplayBannerName(currentExam).toUpperCase()}</h1>
          </>
        )}
        {shouldShowRewardsSection && <p className="card-des">Win up to 100% scholarship and exciting rewards.</p>}
      </figure>
    </div>
  );
};
